import React from 'react'
//Please create ProfileSliderSvc.js 

const ProfileSlider = () => {
    return (
        <div>ProfileSlider</div>
    )
}

export default ProfileSlider